"use strict";
exports.__esModule = true;
exports.VideoType = void 0;
var VideoType;
(function (VideoType) {
    VideoType["Youtube"] = "Youtube";
    VideoType["Libcast"] = "Libcast";
})(VideoType = exports.VideoType || (exports.VideoType = {}));
//# sourceMappingURL=video-hero-slice.js.map